
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import BoxedContainer from '../UI/BoxedContainer';
import { Layout } from 'antd';
import { ConfiguratorContext } from '../../routes/Configurator/context';

const Header: React.FC = () => {
    const navigate = useNavigate();
    const { resetState } = useContext(ConfiguratorContext);

    const handleLogoClick = (e: React.MouseEvent) => {
        e.preventDefault();
        resetState();
        navigate('/');
    };

    return (
        <Layout.Header className='header'>
            <BoxedContainer>
                <a href="/" className='logo-link' onClick={handleLogoClick}>
                    <img className='logo' src="/build/images/logo-eclisse.svg" />
                </a>
            </BoxedContainer>
        </Layout.Header>
    )
}

export default Header;
